// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTabsModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidatorModule
} from 'devextreme-angular';

// Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Module imports
import { SharedModule } from '../../../shared-module/shared.module';
import { ManagementCommonModule } from '../../../management-common/management-common.module';
import { SharedWorkflowModule } from '../../../shared-workflow-module/shared-workflow.module';
import { ProjectTaskEditorModule } from '../../../project-task-module/project-task/project-tasks-editor/project-tasks-editor.module';
import { WorkOrderEditorModule } from '../work-orders-editor/work-orders-editor.module';

// Component imports
import { WorkOrderComponent } from './work-order.component';
import { WorkOrderGridComponent } from '../work-order-grid/work-order-grid.component';
import { WorkOrderManageTasksComponent } from '../work-order-manage-tasks/work-order-manage-tasks.component';
import { WorkOrderManageInvoicesComponent } from '../work-order-manage-invoices/work-order-manage-invoices.component';
import { ManageOpenInvoicesComponent } from '../work-order-manage-invoices/manage-open-invoices/manage-open-invoices.component';
import { ManageClosedInvoicesComponent } from '../work-order-manage-invoices/manage-closed-invoices/manage-closed-invoices.component';
import { ManageInvoiceGridComponent } from '../work-order-manage-invoices/manage-invoice-grid/manage-invoice-grid.component';
import { ManageTaskGridComponent } from '../work-order-manage-tasks/manage-task-grid/manage-task-grid.component';
import { ManageOpenTasksComponent } from '../work-order-manage-tasks/manage-open-tasks/manage-open-tasks.component';
import { ManageClosedTasksComponent } from '../work-order-manage-tasks/manage-closed-tasks/manage-closed-tasks.component';
import { OpenWorkOrdersComponent } from '../open-work-orders/open-work-orders.component';
import { ClosedWorkOrdersComponent } from '../closed-work-orders/closed-work-orders.component';

@NgModule({
    declarations: [
        WorkOrderComponent,
        OpenWorkOrdersComponent,
        ClosedWorkOrdersComponent,
        WorkOrderGridComponent,
        WorkOrderManageTasksComponent,
        WorkOrderManageInvoicesComponent,
        ManageOpenInvoicesComponent,
        ManageClosedInvoicesComponent,
        ManageInvoiceGridComponent,
        ManageTaskGridComponent,
        ManageOpenTasksComponent,
        ManageClosedTasksComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        SharedModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        WorkOrderEditorModule,
        SharedWorkflowModule,
        ProjectTaskEditorModule,
        DxBoxModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxFormModule,
        DxNumberBoxModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxPopupModule,
        DxTabsModule,
        DxDataGridModule,
        DxDropDownButtonModule,
        DxRadioGroupModule,
        DxValidatorModule
    ],
    exports: [
        WorkOrderComponent,
        OpenWorkOrdersComponent,
        ClosedWorkOrdersComponent,
        WorkOrderGridComponent,
        WorkOrderManageTasksComponent,
        WorkOrderManageInvoicesComponent,
        ManageOpenInvoicesComponent,
        ManageClosedInvoicesComponent,
        ManageInvoiceGridComponent,
        ManageTaskGridComponent,
        ManageOpenTasksComponent,
        ManageClosedTasksComponent,
        WorkOrderEditorModule
    ],
    entryComponents: [WorkOrderComponent]
})
export class WorkOrderMainModule {}
